import React from 'react';
import { useParams } from 'react-router-dom';
import { SpeechStream } from '@twigeducation/speechstream';
import AssetGlossaryPage from './AssetGlossaryPage';
import AssetPage from './AssetPage';

const SpeechStreamWithStartingPoints = props => (
    <SpeechStream {...props} startingPoints={['termModalBody']} autoPlay showFixedToolbar fillColor="#0D729A" />
);

const AssetPageRedirect = props => {
    const { type } = useParams();
    if (type === 'glossary-term') return <AssetGlossaryPage {...props} SpeechStream={SpeechStreamWithStartingPoints} />;
    return <AssetPage {...props} />;
};

export default AssetPageRedirect;
